<script lang="ts">
  import type { Snippet } from 'svelte';

  const {
    header,
    body,
    openByDefault: defaultValue = false,
    open,
  }: {
    header: Snippet<[boolean, (newValue: boolean) => void]>;
    body: Snippet;
    openByDefault?: boolean;
    open?: boolean;
  } = $props();

  let isOpen = $state(defaultValue);
  $effect(() => {
    if (typeof open === 'boolean') {
      isOpen = open;
    }
  });
</script>

{@render header(isOpen, (newValue) => {
  isOpen = newValue;
})}
<div class={isOpen ? '' : 'hidden'}>
  {@render body()}
</div>
